import { render } from "./ZlotyIcon.vue?vue&type=template&id=654d0033"
import script from "./ZlotyIcon.vue?vue&type=script&lang=js"
export * from "./ZlotyIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__